export default __webpack_public_path__ + "static/03-02-math-data-analysis-f422d14cbf35b493d41f660ec05f720e.mp4";